import React, { useRef } from 'react';
import PrintIcon from '@mui/icons-material/Print';
import YearOverviewPage from './YearOverviewPage';

interface IProps {
    year: number;
}

const PrintableYearOverviewPage = (props: IProps) => {
    const contentRef = useRef<HTMLDivElement>(null);

    const openInNewTab = () => {
        if (!contentRef.current) return;

        const printWindow = window.open('', '_blank');
        if (!printWindow) return;

        const htmlContent = contentRef.current.innerHTML;

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Jaar Overzicht ${props.year}</title>
                <style>
                    * { margin: 0; padding: 0; box-sizing: border-box; }
                    body {
                        background: #FFFFFF;
                        color: #000000;
                        font-family: Arial, sans-serif;
                        padding: 10mm;
                    }
                    .print-page {
                        width: 100%;
                        background: #FFFFFF;
                        color: #000000;
                        display: flex;
                        flex-direction: column;
                    }
                    .print-header {
                        text-align: center;
                        margin-bottom: 12px;
                        border-bottom: 2px solid #333;
                        padding-bottom: 8px;
                    }
                    .print-title {
                        font-size: 22px;
                        font-weight: bold;
                        margin: 0 0 4px 0;
                        color: #000;
                    }
                    .print-project-code {
                        font-size: 10px;
                        color: #666;
                    }
                    .print-table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-bottom: 10px;
                        table-layout: fixed;
                    }
                    .print-th {
                        background-color: #f0f0f0;
                        border: 1px solid #ddd;
                        padding: 6px 8px;
                        text-align: center;
                        font-weight: bold;
                        font-size: 11px;
                    }
                    .print-td {
                        border: 1px solid #ddd;
                        padding: 5px 8px;
                        text-align: center;
                        font-size: 11px;
                    }
                    .print-mechanic-name-col {
                        background-color: #f9f9f9;
                        font-weight: bold;
                        text-align: left;
                        padding-left: 10px;
                    }
                    .print-total-col {
                        background-color: #e0e0e0;
                        font-weight: bold;
                        width: 100px;
                    }
                    .print-total-cell {
                        background-color: #f5f5f5;
                        font-weight: bold;
                    }
                    .print-totals-row {
                        background-color: #f0f0f0;
                        font-weight: bold;
                    }
                    .print-grand-total {
                        background-color: #e0e0e0;
                        font-weight: bold;
                        font-size: 12px;
                    }
                    .print-summary {
                        border: 1px solid #ddd;
                        padding: 8px 12px;
                        margin-top: 10px;
                        float: right;
                        min-width: 200px;
                        max-width: 240px;
                    }
                    .print-summary-row {
                        display: flex;
                        justify-content: space-between;
                        padding: 3px 0;
                        font-size: 11px;
                    }
                    .print-summary-label { font-weight: normal; }
                    .print-summary-value {
                        font-weight: bold;
                        text-align: right;
                        min-width: 55px;
                    }
                    .print-summary-result {
                        border-top: 1px solid #ddd;
                        margin-top: 3px;
                        padding-top: 3px;
                        font-size: 12px;
                        font-weight: bold;
                    }
                    .positive { color: #22c55e; }
                    .negative { color: #ef4444; }
                    @media print {
                        body { padding: 0; }
                        @page { margin: 15mm; size: A4 portrait; }
                    }
                </style>
            </head>
            <body>
                ${htmlContent}
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    return (
        <React.Fragment>
            <PrintIcon onClick={openInNewTab} style={{ cursor: 'pointer' }} />
            <div ref={contentRef} style={{ position: 'fixed', left: '-9999px', top: 0 }}>
                <YearOverviewPage year={props.year} />
            </div>
        </React.Fragment>
    );
};

export default PrintableYearOverviewPage;
